import axios from "axios";
import buttonTheme from "css/themes/Buttons.css";
import theme from "css/themes/login/registrationTheme.css";
import React, { Component } from "react";
import Dropzone from "react-dropzone";
import { Button } from "react-toolbox/lib/button";
import Spinner from "util/components/spinner";

class UploadButton extends Component {
  state = {
    loading: false,
  };

  render() {
    if (this.state.loading) {
      return <Spinner />;
    }

    let { label } = this.props;

    if (!label) {
      if (!this.props.src) {
        label = LANGUAGE.form.uploadImage;
      } else {
        label = LANGUAGE.form.changeImage;
      }
    }

    const onDrop = async (files) => {
      const { action } = this.props;
      this.setState({
        loading: true,
      });
      const form = new FormData();
      files.forEach((file) => {
        form.append("file", file);
        form.append("name", file.name);
      });
      const { data } = await axios.post(action, form);
      this.setState({
        loading: false,
      });
      this.props.success(data);
    };

    return (
      <div>
        <Dropzone
          className={theme.dropzoneContainer}
          onDropAccepted={onDrop}
          accept={{
            "image/x-png": [],
            "image/jpeg": [],
          }}
          maxSize={1048576}
        >
          {({ getRootProps, getInputProps }) => (
            <section>
              <div {...getRootProps()}>
                <input {...getInputProps()} />
                <Button
                  theme={buttonTheme}
                  className={buttonTheme.greenButton}
                  label={label}
                  raised
                />
              </div>
            </section>
          )}
        </Dropzone>
      </div>
    );
  }
}

export default UploadButton;
